import React from "react";
import HeroImg from "./assets/images/contact-img.jpg";
import Phone from "./assets/icons/phone3.png";
import Gmail from "./assets/icons/gmail3.png";
import Location from "./assets/icons/location2.png";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
// import Testimonials from "./components/Testimonials";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// import { useNavigate } from "react-router-dom";
import Map from "./components/Map";
// ..
AOS.init();

const Contact = () => {
  // const navigate = useNavigate();
  return (
    <div>
      {/* hero-section */}
      <section
        style={{ backgroundImage: `url(${HeroImg})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        {/* <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[80vh] w-full absolute top-0"></div> */}
        <div className="z-10 lg:px-24 md:px-10 px-4 ">
          <div className="lg:w-[55%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl  text-3xl text-white font-semibold md:leading-[3.5rem]">
              Get In Touch!
            </h1>
            <p
              data-aos="fade-in"
              data-aos-delay="0"
              data-aos-duration="2000"
              className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full"
            >
              We're here to help! Whether you have questions about our services,
              want to schedule an appointment, or need to request test results,
              we'd love to hear from you
            </p>
          </div>
        </div>
      </section>

      <div className="bg-gradient-to-b from-primaryPurple/50 to-white lg:px-24 bg-lightGrey md:px-10 px-4 py-10">
        <h1 className="text-primaryPurple py-4 text-center md;w-[70%] w-full mx-auto md:text-2xl lg:text-3xl text-3xl font-bold">
          Contact Us
        </h1>

        <div
          data-aos="fade-up"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="flex md:flex-row flex-col                                                                                                                                                                                                                                          justify-between gap-7"
        >
          <div className="flex flex-col gap-3 md:w-[50%] w-full ">
            <h1 className="text-primaryPurple">Get In Touch</h1>
            <div className="flex items-start  gap-2">
              <img src={Phone} className="w-[1.5rem]" alt="" />
              <div>
                <p className="">Phone</p>
                <p className="text-sm text-gray-600">
                  09165311972, 09157776753
                </p>
              </div>
            </div>

            <div className="flex items-start  gap-2">
              <img src={Gmail} className="w-[1.5rem]" alt="" />
              <div>
                <p className="">Email</p>
                <p className="text-sm text-gray-600">
                  clearicondiagnostics@gmail.com
                </p>
              </div>
            </div>

            <div className="flex items-start gap-2">
              <img src={Location} className="w-[1.5rem]" alt="" />
              <div>
                <p className="">Address</p>
                <p className="text-sm text-gray-600">
                  Shopping Complex, Opp Peculiar Grace Supermarket, Olorunsogo
                  Road. Ilorin, Kwara State
                </p>
              </div>
            </div>

            <div>
              <h1 className=" font-semibold pt-8 pb-4">Follow Us</h1>
              <div className="flex items-center text-2xl text-primaryPurple justify-center md:justify-normal gap-3">
                <FaFacebook />
                <a
                  href="https://x.com/clearicon1?t=j10Uae1mLYf5_QCW8-18iQ&s=09"
                  className="cursor-pointer"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://ng.linkedin.com/company/clear-icon-medic-diagnostics"
                  className="cursor-pointer"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.instagram.com/clearicon_diagnostics?igsh=YzY3eGRjamI1YWJk"
                  className="cursor-pointer"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
          {/* <div className="md:w-[50%] w-full">
            <form action="" className="w-full flex flex-col gap-2">
              <div className="flex items-center w-full gap-2 justify-between">
                <input
                  type="text"
                  className="bg-white py-2 px-4 rounded-md w-[60%]"
                  placeholder="Name"
                />
                <input
                  type="text"
                  className="bg-white py-2 px-4 rounded-md w-[50%]'"
                  placeholder="Email"
                />
              </div>
              <input
                type="text"
                className="bg-white py-2 px-4 rounded-md"
                placeholder="Phone number"
              />
              <input
                type="text"
                className="bg-white py-2 px-4 rounded-md"
                placeholder="Subject"
              />
              <textarea
                name=""
                id=""
                className="border bg-white rounded-md px-4 py-2 h-[8rem] resize-none"
              ></textarea>

              <button className="font-semibold bg-primaryPurple py-3 px-7 text-white mt-2 rounded-md">
                Send Message
              </button>
            </form>
          </div> */}
        </div>
      </div>

      <Map />
      {/* <Testimonials /> */}
    </div>
  );
};

export default Contact;
